let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("22OJV")).then(() => parcelRequire('8dyLy'));